import { ServiceFetch } from '../service-fetch'

export default class ProductInitModel extends ServiceFetch {
    getLineLiffBy = (data) => this.authFetch({
        url: 'line-liff/getLineLiffBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateLineLiffByCode = (data) => this.authFetch({
        url: 'line-liff/updateLineLiffByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}